import React from 'react';
import { createI18N } from '../createI18N';

const i18n = createI18N();

export const I18NContext = React.createContext(i18n);

export function I18NProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return <I18NContext.Provider value={i18n}>{children}</I18NContext.Provider>;
}
